// extracted by mini-css-extract-plugin
export default {"container":"rV-z","title":"sV-z","link":"tV-z"};